import { render, staticRenderFns } from "./BreadcrumbHistory.vue?vue&type=template&id=5a427020&"
import script from "./BreadcrumbHistory.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports